<script>
import { toEngineeringNotation } from "@/utils";

export default {
  props: {
    // The hashrate that has been inputted
    value: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      // The exponent of the hashrate, corresponding to the unit:
      // e.g. GH/s = 9
      exponent: 9,

      // The coefficient of the hashrate (amount without unit)
      coefficient: 0,
    };
  },

  computed: {
    // The step size should be 1 for H/s and 0.01 for anything else.
    step() {
      return this.exponent === 0 ? 1 : 0.01;
    },

    // The current hashrate inputted by the user.
    hashrate() {
      return this.coefficient * Math.pow(10, this.exponent);
    },
  },

  watch: {
    value(value) {
      // If the value hasn't actually changed, ignore .
      if (value == this.hashrate) return;

      // Otherwise, convert the value to engineering notation
      // and save both parts to the controller.
      let eng = toEngineeringNotation(value, {
        minExponent: 0,
        maxExponent: 15,
      });
      this.coefficient = eng.coefficient;
      this.exponent = eng.exponent;
    },
  },

  methods: {
    // Adjust the hashrate coefficient so that the hashrate is a
    // round number of hashes per second, and not more than two decimal
    // places precise. When finished, emit an update.
    adjust() {
      let order = Math.min(100, Math.pow(10, this.exponent));
      this.coefficient = Math.round(this.coefficient * order) / order;
      this.$emit("input", this.hashrate);
    },
  },
};
</script>

<template>
  <b-input-group>
    <b-form-input
      required
      v-model="coefficient"
      type="number"
      min="0"
      id="hashrate"
      placeholder="Hashrate"
      :step="step"
      @blur="adjust"
    ></b-form-input>
    <b-form-select
      required
      v-model="exponent"
      :options="[
        { value: 0, text: 'H/s' },
        { value: 3, text: 'kH/s' },
        { value: 6, text: 'MH/s' },
        { value: 9, text: 'GH/s' },
        { value: 12, text: 'TH/s' },
        { value: 15, text: 'PH/s' },
      ]"
      @change="adjust"
      class="Flex-35"
    ></b-form-select>
  </b-input-group>
</template>

<style scoped>
.input-group > .form-control:not(:last-child) {
  margin-right: 1px;
}

select.Flex-35 {
  flex: 0.35;
}
</style>
